import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import Moment from 'moment';
import React from 'react';
import { Loading } from 'react-loading-ui';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../App.css';
import environment from '../environments/environment';
import CancelModalComponent from '../popUpModals/CancelModalComponent';
import SubmitModalComponent from '../popUpModals/SubmitModalComponent';
import * as constants from '../Constants';

class RunMetricks extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false,
            shows: false,
            attorney: '',
            supervisor: '',
            reportStartDate: new Date(),
            reportEndDate: new Date(),
            isActive: '',
            reDirect: '',
            supervisors: [],
            attorneys: [],
            caseList: [],
            errorReportStartDateMessage: '',
            errorReportEndDateMessage: '',
            supervisorId: 0,
            statusFlag: "All",
            status: constants.IS_ACTIVE_YES,
            attorneyId: 0,
            caseId: 0,
            toDayDate: new Date()
        }
        this.onRenderDayCell = this.onRenderDayCell.bind(this);
    }

    componentDidMount = async () => {
        if (this.props.userStatus.userName !== "") {
            this.setState({
                ...this.state,
                supervisor: this.props.userStatus.userRole === 'Admin' ? '0' : this.props.userStatus.parentId > 0 ? this.props.userStatus.parentId : this.props.userStatus.userId,
                attorney: this.props.userStatus.userRole === 'Admin' ? '0' : this.props.userStatus.parentId > 0 ? this.props.userStatus.userId : '0'
            }, () => {
                this.getSupervisor(this.state.supervisor);
            });
        } else {
            this.setState({
                reDirect: '/',
            });
        }
    }

    getSupervisor(value) {
        axios.get(environment.getAllSupervisors)
            .then(response => {
                if (response.data !== null) {
                    this.setState({
                        supervisors: response.data,
                    });
                    if (value > 0) {
                        this.getAttorney(value);
                    }
                }
            })
    }

    getAttorney(value) {
        axios.get(environment.getAllAttorneys + value)
            .then(response => {
                if (response.data !== null) {
                    this.setState({
                        attorneys: response.data,
                    });
                }
            })
    }

    changeValue = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }, () => {
            if (e.target.name === 'caseName') {
                let caseId;
                for (let i = 0; i < this.state.caseList.length; i++) {
                    if (this.state.caseName === this.state.caseList[i].caseName) {
                        caseId = this.state.caseList[i].caseId;
                    }
                }
                this.setState({
                    ...this.state,
                    caseId: caseId
                }, () => {
                    //this.toValiadetCaseName();
                });
            }
            if (e.target.name === 'attorney') {
                let attorneyId;
                for (let i = 0; i < this.state.attorneys.length; i++) {
                    if (this.state.attorney === this.state.attorneys[i].attorneyName) {
                        attorneyId = this.state.attorneys[i].attorneyId;
                    }
                }
                this.setState({
                    ...this.state,
                    attorneyId: attorneyId
                }, () => {
                    this.getCases();
                    //this.toValiadetAttorney();
                })

            }
            if (e.target.name === 'supervisor') {
                let supervisor;
                for (let i = 0; i < this.state.supervisors.length; i++) {
                    if (this.state.supervisor === this.state.supervisors[i].supervisor) {
                        supervisor = this.state.supervisors[i].supervisorId;
                    }
                }
                this.setState({
                    ...this.state,
                    supervisorId: supervisor,
                    caseList: []
                }, () => {
                    //this.toValiadetSupervisor();
                    this.getAttorney(this.state.supervisorId);
                })
            }
            if (e.target.name === 'reportStartDate') {
                this.toValiadetReportStartDate();
            }
            if (e.target.name === 'reportEndDate') {
                this.toValiadetReportEndDate();
            }
        });
    }

    getCases() {
        let casesearch = {};
        casesearch.attorneyName = this.state.attorney;
        casesearch.supervisor = this.state.supervisor;
        casesearch.attorneyId = this.state.attorneyId;
        casesearch.supervisorId = this.state.supervisorId;
        casesearch.statusFlag = this.state.statusFlag;
        casesearch.status = this.state.status;
        casesearch.mailId = this.props.userStatus.emailId;
        casesearch.userRole = this.props.userStatus.userRole;
        casesearch.pageNo = -1;
        casesearch.pageSize = -1;
        axios.post(environment.getCaseInfoList, casesearch)
            .then(response => {
                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    this.setState({
                        ...this.state,
                        caseList: response.data.caseVOList
                    });
                } else {
                    toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER });
                }
            }
            ).catch((error) => {
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
            });

    }

    async toValiadetReportStartDate() {
        this.setState({
            errorReportStartDateMessage: "",
            errorReportEndDateMessage: "",
        }, () => {
            if (this.state.reportStartDate === null) {
                this.setState({
                    errorReportStartDateMessage: "Report Start date required",
                })
            } else if (this.state.reportStartDate !== "" && this.state.reportEndDate !== "" && (this.state.reportStartDate > this.state.reportEndDate)) {
                this.setState({
                    errorReportEndDateMessage: "Report End Date should be greater than Report Start Date",
                })
            }
        })
    }

    async toValiadetReportEndDate() {
        this.setState({
            errorReportEndDateMessage: "",
        }, () => {
            if (this.state.reportEndDate === null) {
                this.setState({
                    errorReportEndDateMessage: "Report End date required",
                })
            } else if (this.state.reportStartDate !== "" && this.state.reportEndDate !== "" && (this.state.reportStartDate > this.state.reportEndDate)) {
                this.setState({
                    errorReportEndDateMessage: "Report End Date should be greater than Report Start Date",
                })
            }
        })
    }

    async onSubmit(event) {
        event.preventDefault();
        await this.toValiadetReportStartDate();
        await this.toValiadetReportEndDate();
        if (this.state.errorReportEndDateMessage === "" && this.state.errorReportStartDateMessage === "") {
            this.setState({ shows: true });
        }
    }

    onCloseModal() {
        this.setState({ show: false });
    }
    showModal = () => {
        this.setState({ show: true });
    }

    onCancelChanges() {
        this.setState({
            reDirect: "/caseSummary"
        })
    }

    onSubmitModal() {
        this.setState({ shows: false });
    }

    showSubmitModal = () => {
        this.setState({ shows: true });
    }

    onSubmitChanges() {
        this.onSubmitModal();
        this.toSave();
    }

    toSave() {
        Loading();
        let CasesMetricSearchVO = {};
        CasesMetricSearchVO.pageNo = -1;
        CasesMetricSearchVO.pageSize = -1;
        CasesMetricSearchVO.supervisors = this.state.supervisorId;
        CasesMetricSearchVO.attorney = this.state.attorneyId;
        CasesMetricSearchVO.cases = this.state.caseId;
        CasesMetricSearchVO.reportStartDate = Moment(this.state.reportStartDate).format('YYYY-MM-DD HH:mm:ss');
        CasesMetricSearchVO.reportEndDate = Moment(this.state.reportEndDate).format('YYYY-MM-DD HH:mm:ss');
        CasesMetricSearchVO.userName = this.props.userStatus.emailId;
        axios.post(environment.saveCaseMetricsByDates, CasesMetricSearchVO)
            .then(response => {
                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    setTimeout(() => {
                        Loading();
                    });
                    toast.success(response.data.apiResponseVO.message,
                        { position: toast.POSITION.TOP_CENTER }
                    )

                } else {
                    setTimeout(() => {
                        Loading();
                    });
                    toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER })
                }
            })
            .catch((error) => {
                setTimeout(() => {
                    Loading();
                });
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER })
            });
    }
    onRenderDayCell(args) {
        if (this.state.toDayDate !== null) {
            if (this.state.lastReportSent !== null) {
                if ((args.date > this.state.toDayDate)) {
                    // sets isDisabled to true to disable the date.
                    args.isDisabled = true;
                }
            }
        }
    }

    render() {
        if (this.state.reDirect) {
            return <Redirect to={{
                pathname: this.state.reDirect, state: {
                    caseId: this.state.caseId,
                }
            }} />
        }
        return (
            <React.Fragment>
                <form onSubmit={(event) => this.onSubmit(event)}>
                    <div className="container pl-0  pr-0 ">
                        <div className="row mt-1 mb-0">
                            <div className="col-md-6">
                                <h4>Run Metrics</h4>
                            </div>
                        </div>
                        <hr></hr>
                        <div className="row">
                            <div className="col-6">

                                <div className="form-group mt-1 "  >
                                    <div className="row">
                                        <label className="col-8 " style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}><b>Supervisor</b>
                                            <b className="float-left " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>
                                            <select className=" col-12" name="supervisor"
                                                value={this.state.supervisor} onChange={this.changeValue} >
                                                <option value="">All</option>
                                                {this.state.supervisors.map((supervisor) => (
                                                    <option key={supervisor.supervisorId} value={supervisor.supervisor}
                                                    >{supervisor.supervisor}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group  mt-1 " >
                                    <div className="row">
                                        <label style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Attorney </b>
                                            <b className="float-right " style={{ width: '5%' }}>:</b>
                                        </label> <div style={{ width: '35%' }}>
                                            <select className="col-12" name="attorney" value={this.state.attorney}
                                                onChange={this.changeValue}>
                                                <option value="">All</option>
                                                {this.state.attorneys.map((attorney) => (
                                                    <option key={attorney.attorneyId} value={attorney.attorneyName}
                                                    >{attorney.attorneyName}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group  mt-1 " >
                                    <div className="row">
                                        <label style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Case </b>
                                            <b className="float-right " style={{ width: '5%' }}>:</b>
                                        </label>                                <div style={{ width: '35%' }}>
                                            <select className=" col-12" name="caseName" value={this.state.caseName} onChange={this.changeValue}  >
                                                <option value="">All</option>
                                                {this.state.caseList !== undefined && this.state.caseList !== null && this.state.caseList.map((caseVo) => (
                                                    <option key={caseVo.caseId} value={caseVo.caseName}
                                                    >{caseVo.caseName}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group mt-1 "  >
                                    <div className="row">
                                        <label className="col-8 " style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Start Date</b><span className="required"></span>
                                            <b className="float-left " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>
                                            <DatePickerComponent id="reportStartDate" name="reportStartDate" allowEdit={false} showTodayButton={false} enabled={this.state.lastReportSent == null}
                                                value={Moment(this.state.reportStartDate).format('MM/DD/YYYY ')} renderDayCell={this.onRenderDayCell} onChange={this.changeValue} ></DatePickerComponent>
                                            <p className="text-danger" style={{ width: '250px' }}>{this.state.errorReportStartDateMessage} </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group mt-1 "  >
                                    <div className="row">
                                        <label className="col-8 " style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>End Date</b><span className="required"></span>
                                            <b className="float-left " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>

                                            <DatePickerComponent id="reportEndDate" name="reportEndDate" allowEdit={false} showTodayButton={false} enabled={this.state.lastReportSent == null}
                                                value={Moment(this.state.reportEndDate).format('MM/DD/YYYY ')} renderDayCell={this.onRenderDayCell} onChange={this.changeValue} ></DatePickerComponent>
                                            <p className="text-danger" style={{ width: '450px' }}>{this.state.errorReportEndDateMessage} </p>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                        <hr></hr>
                        <main>
                            <div className="row mb-2" >
                                <div>
                                    <button type="submit"
                                        className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Submit  </button>
                                    <button type="button" onClick={this.showModal}
                                        className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Cancel </button>
                                </div>
                            </div>
                            <CancelModalComponent show={this.state.show} hideModal={() => this.onCloseModal()} cancelChanges={() => this.onCancelChanges()}></CancelModalComponent>
                            <SubmitModalComponent show={this.state.shows} hideModal={() => this.onSubmitModal()} submitChanges={() => this.onSubmitChanges()}></SubmitModalComponent>
                        </main>
                        <ToastContainer style={{ marginTop: '7%' }} />
                    </div>
                </form>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer
    }
}

export default connect(mapStateToProps)(RunMetricks);
